import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import "./Pagination.scss";

interface PaginationProps {
  onPageSizeChange: Function;
  onPageChange: Function;
  currentPage: number;
  totalCount: number;
  pageSize: number;
}

export default function Pagination(props: PaginationProps) {
  const { t } = useTranslation();
  const availablePageSizes = [5, 10, 20];
  const numberOfPages: number = Math.ceil(props.totalCount / props.pageSize);

  return (
    <table className="container bg-white border-bottom rounded-bottom pagination-component">
      <tbody>
        <tr className="float-end">
          <td className="ps-3 py-114-rem text-light-gray">
            {t("Rows per page")}:
          </td>
          <td className="py-114-rem">
            <Dropdown
              className="borderless-dropdown"
              onSelect={(size) => {
                props.onPageSizeChange(size);
              }}
            >
              <Dropdown.Toggle className="text-content-black">
                {props.pageSize}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {availablePageSizes.map((availablePageSize, i) => (
                  <Dropdown.Item key={i} eventKey={availablePageSize}>
                    {availablePageSize}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </td>
          <td className="ps-164-rem py-114-rem text-content-black">
            {props.currentPage + 1} {t("of")} {numberOfPages}
          </td>
          <td className="ps-5 py-114-rem">
            <ChevronLeft
              className={
                props.currentPage === 0
                  ? "disabled"
                  : "cursor-pointer text-light-gray"
              }
              onClick={() => {
                if (props.currentPage > 0) {
                  props.onPageChange(props.currentPage - 1);
                }
              }}
            />
          </td>
          <td className="ps-5 py-114-rem pe-4">
            <ChevronRight
              className={
                props.currentPage >= numberOfPages - 1
                  ? "disabled"
                  : "cursor-pointer text-light-gray"
              }
              onClick={() => {
                if (props.currentPage < numberOfPages - 1) {
                  props.onPageChange(props.currentPage + 1);
                }
              }}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
}
